module.exports = __webpack_public_path__ + "static/media/FSSAI.a3f28999.svg";